import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Page from "components/base/Page";
import Spinner from "components/base/Spinner";
import { SupplierStatusChain } from "components/base/Status";
import { Link, useParams } from "react-router-dom";
import ActionsView from "./components/ActionsView";
import CompaniesView from "./components/CompaniesView";
import ManageSupplierView from "./components/ManageSupplierView";
import NDAView from "./components/NDAView";
import SupplierReviewView from "./components/review/SupplierReviewView";
import SupplierPortalView from "./components/SupplierPortalView";
import { FETCH_SUPPLIER_FOR_ONBOARDING } from "./graphql";
import BaseInfoView from "./reviewInfo/BaseInfoView";
import CertificatesView from "./reviewInfo/CertificatesView";

const SupplierDetail = () => {
  const { id } = useParams();

  const { loading, error, data } = useQuery(FETCH_SUPPLIER_FOR_ONBOARDING, {
    variables: { id },
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const draftData = JSON.parse(data.factory.draftData || "{}");

  const supplier = data.factory;

  return (
    <Page
      title={`Onboarding: ${data.factory.nickName}`}
      subtitle={`Class ${data.factory.supplierClass} Supplier`}
      backTo="./.."
      rightButtons={
        <div>
          {supplier.state === "COMPLETED_ONBOARDING" && (
            <Link
              to={`/suppliers/${supplier.id}`}
              target="_blank"
              rel="noopener noreferrer"
              className="mr-4"
            >
              View Supplier
            </Link>
          )}

          <a
            href={`${
              process.env.REACT_APP_SERVER_ADMIN_URL +
              "csr/csrfactory/" +
              supplier.id
            }`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Admin
          </a>
        </div>
      }
    >
      <div className="p-6 text-sm">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12">
            <SupplierStatusChain status={data.factory.state} />
          </div>

          <div className="col-span-8 space-y-6">
            <BaseInfoView values={draftData.basicInfo} />
            <CompaniesView companies={draftData.companies} />
            <CertificatesView data={draftData} />
          </div>

          <div className="col-span-4 space-y-6 flex flex-col">
            <ActionsView supplier={supplier} />

            {(supplier.state === "VERIFIED" ||
              supplier.state === "COMPLETED_ONBOARDING") && (
              <ManageSupplierView supplier={supplier} draftData={draftData} />
            )}

            {supplier.state !== "DRAFT" && data.supplierLatestReview && (
              <SupplierReviewView
                supplierState={supplier.state}
                supplierReview={data.supplierLatestReview}
              />
            )}

            <SupplierPortalView supplier={supplier} />

            <NDAView supplier={supplier} />

            {supplier.state === "TRIAL_ORDER" && data.supplierLatestReview && (
              <SupplierReviewView
                supplierState={supplier.state}
                supplierReview={data.supplierLatestReview}
              />
            )}
          </div>
        </div>
      </div>
    </Page>
  );
};

export default SupplierDetail;
